'use strict'

module.exports = require('./html')



//////////////////
// WEBPACK FOOTER
// ./~/hastscript/index.js
// module id = 401
// module chunks = 168707334958949